<template>
  <label :for="option.id">
    <span class="tile-title"><span class="icon icon-location-alt"></span>{{ option.name }}</span>
    <span class="body-text">
        {{ description }}
        <br>
        <span>
          {{ option.time }}
        </span>
    </span>
    <span class="store-distance"> {{ option.distance }}</span>
    <a :href="option.directions.url" target="_blank" class="store-maps-link">{{option.directions.title}}</a>
  </label>
</template>
<script src="./pickup-point-option-tile.js"/>
